import { Grid, Typography, useMediaQuery } from "@mui/material";
import { Modal } from "../modal";
import Badges1 from "@/assets/image/badge1.png";
import Badges2 from "@/assets/image/badge2.png";
import Badges3 from "@/assets/image/badge3.png";
import Badges4 from "@/assets/image/badge4.png";
import Badges5 from "@/assets/image/badge5.png";
import Badges6 from "@/assets/image/badge6.png";
import Badges7 from "@/assets/image/badge7.png";
import Badges8 from "@/assets/image/badge8.png";
import Badges9 from "@/assets/image/badge9.png";
import Badges10 from "@/assets/image/badge10.png";
import Badges11 from "@/assets/image/badge11.png";
import Badges12 from "@/assets/image/badge12.png";

function Badge({ level }) {
  const md = useMediaQuery("(max-width:450px)");
  return (
    <Modal width={md ? "100%" : "400px"} sx={{ height: "150px" }}>
      <Grid
        display={"flex"}
        flexDirection={"row"}
        gap={"20px"}
        alignItems={"center"}
      >
        {level.level === 1 && <img src={Badges1} />}
        {level.level === 2 && <img src={Badges2} />}
        {level.level === 3 && <img src={Badges3} />}
        {level.level === 4 && <img src={Badges4} />}
        {level.level === 5 && <img src={Badges5} />}
        {level.level === 6 && <img src={Badges6} />}
        {level.level === 7 && <img src={Badges7} />}
        {level.level === 8 && <img src={Badges8} />}
        {level.level === 9 && <img src={Badges9} />}
        {level.level === 10 && <img src={Badges10} />}
        {level.level === 11 && <img src={Badges11} />}
        {level.level === 12 && <img src={Badges12} />}

        <Grid display={"flex"} flexDirection={"column"} gap={"20px"}>
          <Typography sx={{ color: "var(--emr-darkblue)" }} variant="h6">
            {level.title}
          </Typography>
          <Typography sx={{ color: "var(--emr-primary-color-text)" }}>
            {level.desc}
          </Typography>
        </Grid>
      </Grid>
    </Modal>
  );
}

export default Badge;
